import { useLayoutEffect } from './useLayoutEffect';
// Syncs ref from context with ref passed to hook
export function useSyncRef(context, ref) {
    useLayoutEffect(()=>{
        if (context && context.ref && ref) {
            // @ts-expect-error - Type 'T | null' is not assignable to type 'T'
            context.ref.current = ref.current;
            return ()=>{
                // @ts-expect-error - Type 'null' is not assignable to type 'T'
                context.ref.current = null;
            };
        }
    });
}

//# sourceMappingURL=useSyncRef.js.map